import script from "./ModalParametrosRondas.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalParametrosRondas.vue?vue&type=script&setup=true&lang=ts"

import "./ModalParametrosRondas.vue?vue&type=style&index=0&id=21057ee7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21057ee7"]])

export default __exports__